import React from "react";
import { FormattedMessage } from "react-intl";
import { useMutation } from "@apollo/client";
import { ADD_AI_RATING } from "graphql/mutations";
import { useToast } from "hooks";

export default function useAiRating() {
  const { toast } = useToast();
  const [addAiRating, { adding }] = useMutation(ADD_AI_RATING);

  const handleAddAiRating = (params, onComplete) => {
    addAiRating({
      variables: {
        input: {
          params: params,
        },
      },
      onCompleted: () => {
        onComplete();
        toast.success(<FormattedMessage id="useAiRating.Success" />);
      },
      onError: () => toast.error(<FormattedMessage id="useAiRating.Error" />),
    });
  };

  return {
    handleAddAiRating,
    adding,
  };
}
